import React from "react";

import { CardElement } from "@stripe/react-stripe-js";

const StyledCardElement = () => {
  return (
    <CardElement
      id="my-card"
      options={{
        iconStyle: "solid",
        style: {
          base: {
            fontSize: "24px",
            borderRadius: "7px",
            border: "solid 1px black",
          },
        },
      }}
    />
  );
};

export default StyledCardElement;



// WEBPACK FOOTER //
// ./src/layout/stripe/StyledCardElement.js